import Reveal, { Cross } from "@/components/Reveal";
import { useI18n } from "@/i18n";

export default function Skills() {
  const { t } = useI18n();
  return (
    <section id="skills" className="relative scroll-mt-20 border-t border-line px-6 py-24 md:px-10 md:py-32 xl:px-16" data-testid="skills-section">
      <Cross className="right-6 top-16 hidden md:block" />
      <div className="mx-auto max-w-[1440px]">
        <Reveal className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div>
            <div className="text-[11px] tracking-[0.3em] text-gold">{t.skills.label}</div>
            <h2 className="mt-5 font-display text-3xl font-bold text-white md:text-4xl" data-testid="skills-title">{t.skills.title}</h2>
          </div>
          <p className="max-w-sm text-xs leading-relaxed text-zinc-500">{t.skills.sub}</p>
        </Reveal>

        <div className="mt-14 grid gap-px border border-line bg-line md:grid-cols-2 lg:grid-cols-3" data-testid="skills-grid">
          {t.skills.groups.map((group, i) => (
            <Reveal
              key={group.title}
              delay={i * 0.08}
              y={20}
              className={`group bg-ink p-8 transition-colors duration-300 hover:bg-panel ${i === 0 ? "lg:col-span-2" : ""} ${i === 3 ? "lg:col-span-2" : ""}`}
            >
              <div className="flex items-baseline justify-between">
                <h3 className="text-xs font-bold tracking-[0.25em] text-white group-hover:text-gold" data-testid={`skill-group-${i}`}>{group.title}</h3>
                <span className="text-[10px] text-zinc-600">0{i + 1}</span>
              </div>
              <div className="mt-6 flex flex-wrap gap-2">
                {group.items.map((item) => (
                  <span key={item} className="border border-line px-3 py-1.5 text-[11px] tracking-[0.12em] text-zinc-300 transition-all duration-200 group-hover:border-gold/40">
                    {item}
                  </span>
                ))}
              </div>
            </Reveal>
          ))}

          <Reveal y={20} className="relative overflow-hidden bg-panel p-8 lg:col-span-2" data-testid="skills-terminal">
            <div className="scanline" />
            <div className="text-xs font-bold tracking-[0.25em] text-gold">{t.skills.termTitle}</div>
            <div className="mt-6 space-y-2.5">
              {t.skills.term.map((line, i) => (
                <div key={i} className="text-[11px] tracking-[0.1em] text-zinc-400">
                  <span className="mr-2 text-gold">&gt;</span>
                  {line}
                </div>
              ))}
              <div className="flex items-center gap-2 pt-2 text-[11px] text-zinc-400">
                <span className="text-gold">&gt;</span>
                <span className="inline-block h-3.5 w-2 bg-gold blink" />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
